import styled from "styled-components";
import {
  sharedFontCss,
  TypographyProps,
} from "@shared/common/Typography/Typography";
import { typography } from "@shared/common/Themes/typography";

const Typography = styled.div<TypographyProps>`
  ${sharedFontCss};
  font-weight: ${(p) => p.$weight || typography.fontWeights.NORMAL};
  font-family: ${(p) => p.theme.typography.fontFamily};
  transition: color 0.35s;
  ${(p) =>
    p.$ellipsis &&
    `
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  `}
`;

Typography.defaultProps = {
  type: "primary",
  $ellipsis: false,
};

export default Typography;
